import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

class BalanceSellingFiltersView extends PureComponent {
  render() {
    const {
      onChange,
      filtersFormState,
      clients,
    } = this.props;

    return (
      <div className="filters-container admin-payment-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onChange}>
          <FormGroup>
            <label>Created:</label>
            <Input name="date" type="date" placeholder="YYYY-MM-DD"/>
          </FormGroup>
          <FormGroup>
            <label>Client:</label>
            <Select name="client" options={clients} />
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default BalanceSellingFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BalanceSelling/BalanceSellingFilters/BalanceSellingFilters.view.js